export default __webpack_public_path__ + "c5e49971a2a00017b25f52a0c26602a1.svg";